<template>
  <div>
    <el-form
      :model="loginFrom"
      status-icon
      ref="loginFrom"
      label-width="100px"
      style="height: 100%; width: 30%; margin: auto;margin-top: 20px"
    >
      <el-form-item label="原先密码">
        <el-input
          type="password"
          v-model="loginFrom.oldpw"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item label="新的密码">
        <el-input
          type="password"
          v-model="loginFrom.newpw"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item label="确认密码">
        <el-input
          type="password"
          v-model="loginFrom.compw"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="changepw('')">更改密码</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>





<script>
import axios from "axios";
import Qs from "qs";
import global from "../global.vue";
import AES from "../AES.js";

export default {
  data() {
    return {
      loginFrom: {
        oldpw: "",
        newpw: "",
        compw: "",
      },
    };
  },

  methods: {
    changepw() {
      if (
        this.loginFrom.oldpw == "" ||
        this.loginFrom.newpw == "" ||
        this.loginFrom.compw == ""
      ) {
        this.$message("密码不能为空！");
      } else {
        if (this.loginFrom.compw == this.loginFrom.newpw) {
          var reqbody = new Object();
          reqbody.sid = window.localStorage.getItem("stoken");
          reqbody.soldpw = this.loginFrom.oldpw;
          reqbody.snewpw = this.loginFrom.newpw;
          let that = this;
          var stoken = window.localStorage.getItem("stoken");
          // axios.defaults.headers.common["token"] = stoken;
          axios({
            headers: {
              "Content-type": "text/xml",
              "token": stoken,
            },
            method: "post",
            url: global.sserverip + "khchangepw",
            data: reqbody,
          })
            .then(function (res) {
              //TO-DO 先判断下数据是否正确 status
              console.log(res);
              if (res.data=="成功"){
              location.assign(global.swebip + "qtindex/qthomepage");
              }else{
              that.$message(res.data);
              }
            })
            .catch(function (err) {
              console.log(err);
            });
        } else {
          this.$message("新的密码与确认密码需要一致！");
        }
      }
    },
  },
};
</script>
